import React, { useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Colors } from '../constants/Colors';
import { TextReg } from './StyledText';

type Props = {
  text?: string;
  charLimit?: number;
};

export function ExpandableText({ text, charLimit = 250 }: Props) {
  const [expanded, setExpanded] = useState(false);

  const shouldTruncate = (text?.length ?? 0) > charLimit;
  const displayedText = useMemo(() => {
    if (!text || !shouldTruncate || expanded) return text ?? '';

    const firstPart = text.slice(0, charLimit);
    const secondPart = text.slice(charLimit);
    const secondPartFirstSpaceIndex = secondPart.indexOf(' ');

    return firstPart + secondPart.slice(0, secondPartFirstSpaceIndex) + '...';
  }, [text, charLimit, expanded]);

  if (!text) return null;

  return (
    <TextReg>
      {displayedText}{' '}
      {shouldTruncate && (
        <TextReg
          style={styles.expandText}
          onPress={() => setExpanded(!expanded)}
        >
          {'  '}
          {expanded ? 'Show less' : 'Read more'}
        </TextReg>
      )}
    </TextReg>
  );
}

const styles = StyleSheet.create({
  expandText: {
    color: Colors.purple1,
  },
});
